module.exports = __webpack_public_path__ + "img/13-1.f90aa126.jpg";